import { render, staticRenderFns } from "./App.vue?vue&type=template&id=5d16bb08&scoped=true&"
import script from "./App.vue?vue&type=script&scoped=true&lang=js&"
export * from "./App.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&lang=css&"
import style1 from "./App.vue?vue&type=style&index=1&id=5d16bb08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d16bb08",
  null
  
)

export default component.exports